// Translations
export const T = {
  en_GB: {
    noProductsInPortfolio: "No products in portfolio.",
    noCostDataAvailable: "No cost data available for products.",
    product: "Product",
    weightedCost: "Portfolio weighted cost",
    overrideFee: (fee: string, product: string) => `Override ${fee} for ${product}`,
    partialCoverageNew: (pct: string) =>
      `Only ${pct}% of the portfolio could be analyzed because cost data is missing.`,
    partialCoverageExisting: (pct: string) =>
      `Only ${pct}% of the existing portfolio could be analyzed because cost data is missing.`,
  },
  nb_NO: {
    noProductsInPortfolio: "Ingen produkter i porteføljen.",
    noCostDataAvailable: "Ingen kostnadsdata tilgjengelig for produkter.",
    product: "Produkt",
    weightedCost: "Vektet porteføljekostnad",
    overrideFee: (fee: string, product: string) => `Overstyr ${fee} for ${product}`,
    partialCoverageNew: (pct: string) =>
      `Bare ${pct} % av porteføljen kunne analyseres fordi kostnadsdata mangler.`,
    partialCoverageExisting: (pct: string) =>
      `Bare ${pct} % av den eksisterende porteføljen kunne analyseres fordi kostnadsdata mangler.`,
  },
} as const;
